var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalBriefcaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_4119_1438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9998 3.99984H13.9997V3C14.0002 1.34297 12.6567 0 11.0002 0H7.00031C5.34328 0 4.00031 1.34297 4.00031 3V3.99984H2.00016C0.896719 4.00313 0.00328125 4.89703 0 6V15.9998C0.00328125 17.1028 0.896719 17.9967 2.00016 18H16.0003C17.1033 17.9967 17.9972 17.1033 18.0005 15.9998V6C17.9972 4.89703 17.1038 4.00313 16.0003 3.99984H15.9998ZM6 3C6 2.44781 6.44766 2.00016 6.99984 2.00016H10.9997C11.5519 2.00016 11.9995 2.44781 11.9995 3V3.99984H5.99953V3H6Z",
    fill: "#4FC0CF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.65545 9.65352C7.57201 9.65352 7.50873 9.65352 7.44545 9.65352C6.97107 9.65352 6.26186 9.65211 5.78748 9.65398C5.40967 9.65539 5.19967 9.86398 5.19873 10.2413C5.19873 10.5174 5.19873 11.477 5.19873 11.7587C5.20014 12.1393 5.40545 12.3432 5.78607 12.3446C6.26654 12.3465 6.98139 12.3446 7.46186 12.3446C7.52326 12.3446 7.58514 12.3446 7.65592 12.3446C7.65592 12.9104 7.65498 13.6834 7.65592 14.222C7.65686 14.5899 7.86217 14.7995 8.23248 14.8018C8.56107 14.8018 9.49576 14.8018 9.76717 14.8018C10.1417 14.7999 10.3461 14.5862 10.3475 14.2046C10.3489 13.7302 10.3475 13.021 10.3475 12.5466C10.3475 12.4843 10.3475 12.422 10.3475 12.3446C10.4333 12.3446 10.4961 12.3446 10.5594 12.3446C11.0398 12.3446 11.7547 12.3465 12.2351 12.3437C12.589 12.3418 12.8019 12.1271 12.8019 11.7713C12.8019 11.4699 12.8019 10.5301 12.8019 10.2366C12.8009 9.87195 12.5881 9.65586 12.2248 9.65352C11.7444 9.6507 11.0295 9.65258 10.549 9.65258C10.4867 9.65258 10.4248 9.65258 10.3475 9.65258C10.3475 9.56727 10.3475 9.50398 10.3475 9.4407C10.3475 8.96633 10.3494 8.25711 10.347 7.78273C10.3451 7.40914 10.1295 7.19727 9.75404 7.19727C9.52014 7.19727 8.46967 7.19727 8.27186 7.19727C7.85795 7.19727 7.65592 7.39789 7.65545 7.80852C7.65498 8.33539 7.65545 9.09617 7.65545 9.65258V9.65352Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4119_1438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalBriefcaseIcon);
export default __webpack_public_path__ + "static/media/medical-briefcase-icon.6d5cf4b008782197cf28cd8ecaf30227.svg";
export { ForwardRef as ReactComponent };